import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const VisaUkrainePopup = (props) => {
    const { visaUkraineNotificationText } = usePageMessages();
    const onClickHandler = () => {
        props.toggleSpinner(true);
        props.popupRef?.current?.close();
    };

    return (
        <SimplePopup popupRef={props.popupRef} text={<DangerouslyHtml dangerouslyHtml={props.text ?? visaUkraineNotificationText} />}>
            <PopupButton iconName="check" href={props.continueButtonUrl} text={props.continueButtonText} onClick={onClickHandler} />
            <PopupButton iconName="arrow-exchange" href={props.changeButtonUrl} text={props.changeButtonText} onClick={onClickHandler} />
        </SimplePopup>
    );
};

export default connect(null, { toggleSpinner })(VisaUkrainePopup);
